import { Component, OnInit, Input, EventEmitter, Output, OnDestroy, inject } from "@angular/core";
import { VarianceService } from "src/app/services/variance.service";
import { AuthService } from 'src/app/services/auth.service';
import { ResolutionCodingService } from 'src/app/services/resolution-coding.service';
import { DocumentService } from "src/app/services/document.service";
import { environment } from "src/environments/environment";
import { NursingAuditService } from 'src/app/services/nursing-audit.service';
import { ILogger, LOGGER_TOKEN } from 'src/app/services/logger/ilogger';

@Component({
    selector: "app-comment-modal",
    templateUrl: "./comment-modal.component.html",
    styleUrls: ["./comment-modal.component.css"],
    standalone: false
})
export class CommentModalComponent implements OnInit, OnDestroy {
  private readonly logger = inject<ILogger>(LOGGER_TOKEN);
  private audService = inject(NursingAuditService);
  private varService = inject(VarianceService);
  authService = inject(AuthService);
  resolutionCodingService = inject(ResolutionCodingService);
  documentService = inject(DocumentService);

  @Input() selectedRow: any;
  @Input() deId=false;
  comment = ''
  userAction = '';
  resCoding! : string;
  comments: any;
  resolutionOptions:any;
  msgs!:[];
  transType! : boolean; 
  tab = 1;
  pollInterval:any;
  isLocked = false;
  totalCount: any = 0;
  lockInfo:any = null;
  lockMessage = '';
  practiceIssueOptions:any;
  practiceIssue:any=[];
  createdAt!:Date;
  sourceResCode!:string;
  userMentions: object[] = [];
  taggedUsers: object[] = [];
  @Output() completed = new EventEmitter<any>();
  ngOnInit(): void {
     
    /** MP:122 and MP:123*/
    try {
      this.resolutionOptions = this.resolutionCodingService.getRosolutionCodingData("variance");
    }
    catch {
      this.resolutionCodingService.getNewResolutionCode().subscribe(() => {
        this.resolutionOptions = this.resolutionCodingService.getRosolutionCodingData("variance");
      })
    }

    try {
      this.practiceIssueOptions = this.resolutionCodingService.getPracticeIssueOptions();
    }
    catch {
      this.resolutionCodingService.getNewResolutionCode().subscribe((res) => {
        this.practiceIssueOptions = (res as any)['practiceIssueData'];
      })
    }
  }
  
  openTab(num: any){
    this.documentService.tab = num;
  }

  private sanitizeComment(comment: string): string {
    if (!comment) return '';
    return comment
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  private encodeSymbolsForBackend(value: string): string {
    if (!value) {
      return '';
    }

    return value
      .replace(/>=/g, '[[GTEQ]]')
      .replace(/<=/g, '[[LTEQ]]')
      .replace(/</g, '[[LT]]')
      .replace(/>/g, '[[GT]]')
      .replace(/&/g, '[[AND]]');
  }

  async getComments(rowData: any) {
    try {
      this.selectedRow = rowData;
      this.transType = (this.selectedRow.transType=='Verified')?true:false;
      this.comment = "";
      this.taggedUsers = [];
      this.comments = [];
      this.totalCount = 0;
      const key = this.selectedRow["lanId"]+this.selectedRow["medId"]+this.selectedRow["varDateString"]
      const adminId = this.selectedRow["lanId"];
      const maapKey = this.selectedRow["maapKey"];
      this.resCoding = this.selectedRow.resolutionCoding;
      this.createdAt = this.selectedRow.createdAt;
      this.practiceIssue = this.selectedRow.practiceIssue;
      this.sourceResCode = this.selectedRow.sourceResCode;
      this.varService.getUrcComments(key, adminId, maapKey, rowData.id).subscribe((res)=>{
        this.comments = ((res as any)["docs"] || []);
        this.comments = this.comments.map((c: any) => {
          if(c['userAction']){
            const actionSplit = c['userAction'].replaceAll(",", "\n")
            c['userAction'] = actionSplit
          }
          return c
        })
        this.comments = this.comments.sort((a: any, b: any) => {
          const dateA = new Date(a['createdAt']).getTime();
          const dateB = new Date(b['createdAt']).getTime();

          if (isNaN(dateA) && isNaN(dateB)) return 0;
          if (isNaN(dateA)) return 1;
          if (isNaN(dateB)) return -1;

          return dateB - dateA;
        });
        this.totalCount = (res as any)["count"];
      },
      (err) => {
        this.logger.exception(err)
        this.comments = [];
        this.totalCount = 0;
      });
    } catch (err) {
      this.logger.exception(err)
      this.comments = [];
    }
  }

  async closeDialog(){
    this.completed.emit(true);
  }
  
  //Updated MV2-425 in line no 60,62 and 66
  async submit() {
    try {
      const key = this.selectedRow["lanId"]+this.selectedRow["medId"]+this.selectedRow["varDateString"]
      const transType = (this.transType) ? 'Verified' : ''

      const rawComment = (this.comment as string) || '';
      const sanitizedComment = this.sanitizeComment(rawComment);
      const encodedComment = this.encodeSymbolsForBackend(rawComment);
      const sanitizedUserAction = this.sanitizeComment(this.userAction as string);
      const encodedResolutionCoding = this.encodeSymbolsForBackend(this.resCoding as string);

      if(this.resCoding != this.selectedRow.resolutionCoding){
        if(sanitizedUserAction != '')
        this.userAction =  sanitizedUserAction + ",Variance Type Changed to " + this.resCoding
        else
        this.userAction =  sanitizedUserAction + "Variance Type Changed to " + this.resCoding
      }
      for(const p of this.selectedRow.practiceIssue){
        if(!this.practiceIssue.includes(p)){
          if(sanitizedUserAction != '')
          this.userAction = sanitizedUserAction + ",Practice Issue Removed - " + p
          else
          this.userAction = sanitizedUserAction + "Practice Issue Removed - " + p
        }
      }
      for(const p of this.practiceIssue){
        if(!this.selectedRow.practiceIssue.includes(p)){
          if(sanitizedUserAction != '')
          this.userAction = sanitizedUserAction + ",Practice Issue Added - " + p
          else
          this.userAction = sanitizedUserAction + "Practice Issue Added - " + p
        }
      }
      let userName = "******, ******"
      const formattedDate = this.selectedRow.varDateString.replace('T', ' ').slice(0,-8)
      if(!this.deId)
        userName = this.selectedRow['employeeName']
      const sender = this.authService.user.email
      await this.varService
      .submitDescripencyStatus(
        this.selectedRow["id"], 
        encodedComment,
        sanitizedUserAction,
        encodedResolutionCoding, 
        key,
        transType,
        this.practiceIssue, 
        this.taggedUsers, 
        this.selectedRow['lanId'], 
        this.selectedRow['adminGroup'], 
        userName, 
        this.selectedRow['loc'],
        this.selectedRow.mrnNum,
        formattedDate,
        this.selectedRow['medDesc'],
        sender).subscribe(
        () => {
        this.userAction = ''
         const message= {
          life:5000,
           severity: 'success', 
           summary: 'Updated Successfully',
           detail: '',
          }
          this.completed.emit(message);
        },
        (err) => {
          const message= {
            life:5000,
            severity: 'error', 
            summary: 'Update Failed',
            detail: err.error.message,
           }
           this.completed.emit(message);
        }
      );
      await this.audService
        .submitComment(userName, this.selectedRow["lanId"], "All", encodedComment, encodedResolutionCoding, 
          this.selectedRow["_id"], 90, encodedResolutionCoding, this.taggedUsers, 
          this.selectedRow['locationGrouping'], this.selectedRow['adminGroup'], true)

      //Update message alert for success / failure MV2-445
      this.selectedRow.comment = sanitizedComment;
      this.selectedRow.resolutionCoding = this.resCoding;
      this.selectedRow.transType = transType;
      this.selectedRow.practiceIssue = this.practiceIssue;
    } catch {
      // Intentionally ignore here; API error is handled by the observable callback.
    }
  }

  startPolling(){
    this.stopPolling();
    this.pollInterval = setInterval(() => {
      this.checkStatus()
    }, environment.lockDuration||60);
    this.checkStatus()
  }

  stopPolling(){
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
      this.pollInterval = null;
    }
  }

  checkStatus(){
    this.documentService.checkLockStatus(this.selectedRow["id"], "variance").subscribe((response)=>{
      this.isLocked = (response as any)["islocked"]
      this.lockInfo = response
      this.lockMessage = this.buildLockMessage();
    },
    ()=>{
      this.isLocked = true
      this.lockMessage = '';
    }
    )
  }

  private buildLockMessage(): string {
    if (this.lockInfo == null) return '';
    try {
      if (["", null].includes(this.lockInfo["lasteEditedBy"])) {
        return "";
      }
      if (!this.isLocked) {
        const createdDate = new Date(
          this.lockInfo["lastEditedAt"]
        ).toLocaleString();
        return (
          "Last Edited By (" +
           this.isDeId(this.lockInfo["lasteEditedBy"]) +
          " - " +
          createdDate +
          ")"
        );
      } else {
        if (["", null].includes(this.lockInfo["userName"])) {
          return "";
        }
        return "In Use By " + this.isDeId(this.lockInfo["userName"]);
      }
    } catch {
      return "";
    }
  }

  formatDateCustom(dateStr: string): string {
    if (environment.convert_times) {
      // Assume dateStr is already in local time string format, just reformat for table
      const dateObj = new Date(dateStr);
      const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
      const date = dateObj.getDate().toString().padStart(2, '0');
      const fullYear = dateObj.getFullYear();
      const hours = dateObj.getHours().toString().padStart(2, '0');
      const minutes = dateObj.getMinutes().toString().padStart(2, '0');
      // const seconds = dateObj.getSeconds().toString().padStart(2, '0');
      // Format: MM/DD/YYYY | HH:mm
      return `${month}/${date}/${fullYear} | ${hours}:${minutes}`;
    } else {
      // Use UTC formatting as before
      let output = '';
      const dateObj = new Date(dateStr);
      const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, '0');
      output += month + '/';
      const date = (dateObj.getUTCDate()).toString().padStart(2, '0');
      output += date + '/';
      const fullYear = dateObj.getUTCFullYear();
      output += fullYear + ' | ';
      const hours = (dateObj.getUTCHours()).toString().padStart(2, '0');
      output += hours + ':';
      const minutes = (dateObj.getUTCMinutes()).toString().padStart(2, '0');
      output += minutes;
      return output;
    }
  }


  ngOnDestroy(){
    this.stopPolling();
  }

  updateDocumentCount(count: any) {
    if(this.totalCount > 0){
      this.totalCount=this.totalCount - count;
    } else {
      this.totalCount = 0;
    }
  }

  updateCount(count: any){
    this.totalCount=this.totalCount + count;
  }

  isDeId(name: any){
    if(this.deId)
      return "xxxxxx xxxxxx"
    else
      return name
  }

  getHistoryBlurClass(){
    return this.deId ? 'blurred-content' : '';
  }

  practiceIssueUpdate(){
    for(const p of this.selectedRow.practiceIssue){
      if(!this.practiceIssue.includes(p)){
        if(this.userAction != '')
        this.userAction = this.userAction + "Practice Issue Removed - " + p
        else
        this.userAction = this.userAction + "Practice Issue Removed - " + p
      }
    }
    for(const p of this.practiceIssue){
      if(!this.selectedRow.practiceIssue.includes(p)){
        if(this.userAction != '')
        this.userAction = this.userAction + "Practice Issue Added - " + p
        else
        this.userAction = this.userAction + "Practice Issue Added - " + p
      }
    }
  }

  resCodeUpdate(){
    if(this.userAction != ''){
      this.userAction = " and Variance Type Changed to " + this.resCoding
    }
    else{
      this.userAction = "Variance Type Changed to " + this.resCoding
    }
    
  }

  getUserMentions(){
    this.authService.getActiveUsers().subscribe((res)=>{
      this.userMentions = (res as any)['users']
    })
  }

    formatName(name: string): string {
    if (!name) return name;
    let formattedName = name.replace(/,\s*/g, ', ');
    
    // Capitalize first letter of each word
    formattedName = formattedName.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
    
    return formattedName;
  }
}
